import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tenant-custom-form-sended',
    templateUrl: './tenant-custom-form-sended.component.html',
    styleUrls: ['./tenant-custom-form-sended.component.scss']
})
export class TenantCustomFormSendedComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
